export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14588.be46b5e6.jpg";